import Vue from 'vue'
import VueRouter from 'vue-router'
import login from "@/views/login";
import index from "@/views/index"
import Router from "vue-router";
import home from "@/views/home/home-new";
import Detail from '@/views/aged/aged_detail'



Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'login',
        component: login,
        hidden:true
    },{
        path: '/index',
        name: 'index',
        component: index,
        children:[
            {
                path: '/long-care/workbench',
                name: 'longCareWorkbench',
                component: resolve => require(['@/views/longCare/index.vue'], resolve),
                props: { page: 'workbench' },
                meta: { title: '长护险工作台', keepAlive: false }
            },
            {
                path: '/long-care/services',
                name: 'longCareServices',
                component: resolve => require(['@/views/longCare/index.vue'], resolve),
                props: { page: 'services' },
                meta: { title: '长护险服务管理', keepAlive: false }
            },
            {
                path: '/long-care/assessments',
                name: 'longCareAssessments',
                component: resolve => require(['@/views/longCare/index.vue'], resolve),
                props: { page: 'assessment' },
                meta: { title: '长护险评估管理', keepAlive: false }
            },
            {
                path: '/long-care/service-agreements',
                name: 'longCareServiceAgreements',
                component: resolve => require(['@/views/longCare/index.vue'], resolve),
                props: { page: 'agreements', kind: '老人服务协议' },
                meta: { title: '服务协议管理', keepAlive: false }
            },
            {
                path: '/long-care/caregiver-agreements',
                name: 'longCareCaregiverAgreements',
                component: resolve => require(['@/views/longCare/index.vue'], resolve),
                props: { page: 'agreements', kind: '护理员协议' },
                meta: { title: '护理员协议管理', keepAlive: false }
            },
            {
                path: '/long-care/caregivers',
                name: 'longCareCaregivers',
                component: resolve => require(['@/views/longCare/index.vue'], resolve),
                props: { page: 'caregivers' },
                meta: { title: '护理员管理', keepAlive: false }
            },
            {
                path: '/home/home-new',
                name: 'Home',
                component: home,
                meta:{
                    keepAlive: true
                }
            },
            {
                path: '/aged/aged_detail',
                name: 'detail',
                component: resolve => require(['@/views/aged/aged_detail'],resolve)

            },
            {
                // 睡眠雷达属于设备管理的基础工作台页面。菜单数据通过异步接口注册，
                // 直达 URL 时不能等待菜单接口完成，否则 router-view 会因为无匹配路由而空白。
                path: '/lifeRader/life',
                name: 'lifeRadarWorkbench',
                component: resolve => require(['@/views/lifeRader/life'], resolve),
                meta: {
                    title: '雷达睡眠检测',
                    keepAlive: false
                }
            },
            {
                // 雷达波看护看板一次加载全部睡眠雷达与 2024 跌倒雷达设备，不使用分页。
                path: '/nbiot/radarWaveCareDashboard',
                name: 'radarWaveCareDashboard',
                component: resolve => require(['@/views/nbiot/radarWaveCareDashboard/RadarWaveCareDashboard'], resolve),
                meta: {
                    title: '雷达波看护看板',
                    keepAlive: false
                }
            },
            {
                // 物联网菜单同样会由 ya-system 的菜单接口注册；静态路由保证直接访问 URL 时不会白屏。
                path: '/iot/operation',
                name: 'iotOperation',
                component: resolve => require(['@/views/iot/operation'], resolve),
                meta: {
                    title: '物联网运维',
                    keepAlive: false
                }
            },
            {
                path: '/institution/aiDailyConsumption',
                name: 'aiDailyConsumption',
                component: resolve => require(['@/views/institution/aiDailyConsumption'], resolve),
                meta:{
                    title: 'AI老人消费总结',
                    keepAlive: false
                }
            },
            {
                path: '/institution/aiFinanceFactChain',
                name: 'aiFinanceFactChain',
                component: resolve => require(['@/views/institution/aiFinanceFactChain'], resolve),
                meta:{
                    title: 'AI数据链消费统计',
                    keepAlive: false
                }
            },
            // HDCS测试页面
            {
                path: '/device/hdcs_test',
                name: 'hdcs_test',
                component: resolve => require(['@/views/device/hdcs_test'],resolve),
                meta:{
                    title: 'HDCS测试',
                    keepAlive: false
                }
            },
            // HDCS模拟器页面
            {
                path: '/device/hdcs_simulator',
                name: 'hdcs_simulator',
                component: resolve => require(['@/views/device/hdcs_simulator'],resolve),
                meta:{
                    title: 'HDCS模拟器',
                    keepAlive: false
                }
            },
            {
                path: '/device/ktbg602_probe',
                name: 'ktbg602_probe',
                component: resolve => require(['@/views/device/ktbg602_probe'],resolve),
                meta:{
                    title: 'KTBG602蓝牙网关接入探针',
                    keepAlive: false
                }
            },
            // 产品说明文件页面
            {
                path: '/erweima/product',
                name: 'erweimaProduct',
                component: resolve => require(['@/views/erweima/product'],resolve),
                meta:{
                    title: '产品说明文件',
                    keepAlive: false
                }
            },
            {
                // 双峰随访包检测数据主页，卡片由后端下发的检测类型自动生成。
                path: '/sonka/sonka',
                name: 'sonka',
                component: resolve => require(['@/views/sonka/sonka'],resolve),
                meta:{
                    title: '双峰随访包检测数据',
                    keepAlive: false
                }
            },
            {
                // 通用检测数据详情页，按路由 type 参数动态渲染列，十类数据共用一个组件。
                path: '/sonka/detail/:type',
                name: 'sonkaDetail',
                component: resolve => require(['@/views/sonka/detail'],resolve),
                meta:{
                    title: '检测数据详情',
                    keepAlive: false
                }
            }

        ],
    },{
        path: '/manageV',
        name: 'manageV',
        component: resolve => require(['@/views/im/Manage'],resolve),
        meta:{
            title: '工作人员',
            keepAlive: false
        }
    },{
        path: '/ageV',
        name: 'ageV',
        component: resolve => require(['@/views/im/Age'],resolve),
        meta:{
            title: '老人',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_59',
        name: 'report_big_screen_59',
        alias: '/report/eldercare_cockpit',
        component: resolve => require(['@/views/report/report_big_screen_59'],resolve),
        meta:{
            title: '智慧康养大数据驾驶舱',
            keepAlive: false
        }
    },{
        path: '/report/station-account-switch',
        name: 'stationAccountSwitch',
        hidden: true,
        component: resolve => require(['@/views/report/station_account_switch'],resolve),
        meta: {
            title: '站点账号切换',
            keepAlive: false,
            publicRoute: true
        }
    },{
        path: '/report/report_big_screen_100',
        name: 'report_big_screen_100',
        component: resolve => require(['@/views/report/report_big_screen_100'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_105',
        name: 'report_big_screen_105',
        component: resolve => require(['@/views/report/report_big_screen_105'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_21',
        name: 'report_big_screen_21',
        component: resolve => require(['@/views/report/report_big_screen_21'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_15',
        name: 'report_big_screen_15',
        component: resolve => require(['@/views/report/report_big_screen_15'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_20',
        name: 'report_big_screen_20',
        component: resolve => require(['@/views/report/report_big_screen_20'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_22',
        name: 'report_big_screen_22',
        component: resolve => require(['@/views/report/report_big_screen_22'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_50',
        name: 'report_big_screen_50',
        component: resolve => require(['@/views/report/report_big_screen_50'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_14',
        name: 'report_big_screen_14',
        component: resolve => require(['@/views/report/report_big_screen_14'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_26',
        name: 'report_big_screen_26',
        component: resolve => require(['@/views/report/report_big_screen_26'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_27',
        name: 'report_big_screen_27',
        component: resolve => require(['@/views/report/report_big_screen_27'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_28',
        name: 'report_big_screen_28',
        component: resolve => require(['@/views/report/report_big_screen_28'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    }, {
        path: '/report/report_big_screen_2',
        name: 'report_big_screen_2',
        component: resolve => require(['@/views/report/report_big_screen_2'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_25',
        name: 'report_big_screen_25',
        component: resolve => require(['@/views/report/report_big_screen_25'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_51',
        name: 'report_big_screen_51',
        component: resolve => require(['@/views/report/report_big_screen_51'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_52',
        name: 'report_big_screen_52',
        component: resolve => require(['@/views/report/report_big_screen_52'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_53',
        name: 'report_big_screen_53',
        component: resolve => require(['@/views/report/report_big_screen_53'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_54',
        name: 'report_big_screen_54',
        component: resolve => require(['@/views/report/report_big_screen_54'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_60',
        name: 'report_big_screen_60',
        component: resolve => require(['@/views/report/report_big_screen_60'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_24',
        name: 'report_big_screen_24',
        component: resolve => require(['@/views/report/report_big_screen_24'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_29',
        name: 'report_big_screen_29',
        component: resolve => require(['@/views/report/report_big_screen_29'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_30',
        name: 'report_big_screen_30',
        component: resolve => require(['@/views/report/report_big_screen_30'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_61',
        name: 'report_big_screen_61',
        component: resolve => require(['@/views/report/report_big_screen_61'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_55',
        name: 'report_big_screen_55',
        component: resolve => require(['@/views/report/report_big_screen_55'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_1',
        name: 'report_big_screen_1',
        component: resolve => require(['@/views/report/report_big_screen_1'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_3',
        name: 'report_big_screen_3',
        component: resolve => require(['@/views/report/report_big_screen_3'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_4',
        name: 'report_big_screen_4',
        component: resolve => require(['@/views/report/report_big_screen_4'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_56',
        name: 'report_big_screen_56',
        component: resolve => require(['@/views/report/report_big_screen_56'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_57',
        name: 'report_big_screen_57',
        component: resolve => require(['@/views/report/report_big_screen_57'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/screen',
        name: 'screen_all',
        component: resolve => require(['@/views/screen/ScreenShow'],resolve),
        meta:{
            title: '智慧养老大数据管理平台',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/aged_map',
        name: 'aged_map',
        component: resolve => require(['@/views/report/bigDate/aged_map'],resolve),
        meta:{
            title: '长者大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/aged_date',
        name: 'aged_date',
        component: resolve => require(['@/views/report/bigDate/aged_date'],resolve),
        meta:{
            title: '长者大数据',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/health_record',
        name: 'health_record',
        component: resolve => require(['@/views/report/bigDate/health_record'],resolve),
        meta:{
            title: '长者健康大数据',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/bed_transform',
        name: 'bed_transform',
        component: resolve => require(['@/views/report/bigDate/bed_transform'],resolve),
        meta:{
            title: '家庭养老床位大数据',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/door_service',
        name: 'door_service',
        component: resolve => require(['@/views/report/bigDate/door_service'],resolve),
        meta:{
            title: '上门服务大数据',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/fuwu_map',
        name: 'fuwu_map',
        component: resolve => require(['@/views/report/bigDate/fuwu_map'],resolve),
        meta:{
            title: '服务大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/bed_map',
        name: 'bed_map',
        component: resolve => require(['@/views/report/bigDate/bed_map'],resolve),
        meta:{
            title: '床位改造大数据地图',
            keepAlive: false
        }
    }, {
        path: '/report/bigDate/anfang_map',
        name: 'anfang_map',
        component: resolve => require(['@/views/report/bigDate/anfang_map'],resolve),
        meta:{
            title: '安防设备大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/chuangdian_map',
        name: 'chuangdian_map',
        component: resolve => require(['@/views/report/bigDate/chuangdian_map'],resolve),
        meta:{
            title: '床垫大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/leidabo_map',
        name: 'leidabo_map',
        component: resolve => require(['@/views/report/bigDate/leidabo_map'],resolve),
        meta:{
            title: '雷达波大数据地图',
            keepAlive: false
        }
    },{
        path: '/report/bigDate/shouhuan_map',
        name: 'shouhuan_map',
        component: resolve => require(['@/views/report/bigDate/shouhuan_map'],resolve),
        meta:{
            title: '手环大数据地图',
            keepAlive: false
        }
    },
    {
        path: '/report/bigDate/newShouhuan',
        name: 'newShouhuan',
        component: resolve => require(['@/views/report/bigDate/newShouhuan'],resolve),
        meta:{
            title: '手环大数据地图',
            keepAlive: false
        }
    },
    {
        path: '/report/bigDate/yunxinxiongka',
        name: 'yunxinxiongka',
        component: resolve => require(['@/views/report/bigDate/yunxinxiongka'],resolve),
        meta:{
            title: '胸卡大数据地图',
            keepAlive: false
        }
    },
    {
        path: '/aotong/full_screen',
        name: 'full_screen',
        component: resolve => require(['@/views/aotong/full_screen'],resolve),
        meta:{
            title: '火柴人监控全屏',
            keepAlive: false
        }
    },
    {
        path: '/report/bigDate/shengming_Radar',
        name: 'shengming_Radar',
        component: resolve => require(['@/views/report/bigDate/shengming_Radar'],resolve),
        meta:{
            title: '生命雷达波大数据地图',
            keepAlive: false
        },
    },
    {
        path: '/h5/my',
        name: 'my',
        component: resolve => require(['@/views/h5/my'], resolve),
        meta: {
            title: '我的',
            keepAlive: false
        },
    },
    {
        path: '/h5/service',
        name: 'service',
        component: resolve => require(['@/views/h5/service'], resolve),
        meta: {
            title: '工单',
            keepAlive: false
        },
    },
    {
        path: '/report/report_big_screen_58',
        name: 'report_big_screen_58',
        component: resolve => require(['@/views/report/report_big_screen_58'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },
    {
        path: '/report/wx_report/report_1',
        name: 'report_1',
        component: resolve => require(['@/views/report/wx_report/report_1'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },
    {
        path: '/report/wx_report/report_2',
        name: 'report_2',
        component: resolve => require(['@/views/report/wx_report/report_2'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },
    {
        path: '/report/wx_report/report_3',
        name: 'report_3',
        component: resolve => require(['@/views/report/wx_report/report_3'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/wx_report/report_4',
        name: 'report_4',
        component: resolve => require(['@/views/report/wx_report/report_4'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/big_aged',
        name: 'big_aged',
        component: resolve => require(['@/views/report/xiangqing/big_aged'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/big_gai_zhao',
        name: 'big_gai_zhao',
        component: resolve => require(['@/views/report/xiangqing/big_gai_zhao'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/ji_gou_lie_biao',
        name: 'ji_gou_lie_biao',
        component: resolve => require(['@/views/report/xiangqing/ji_gou_lie_biao'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/ji_gou_xiang_qing',
        name: 'ji_gou_xiang_qing',
        component: resolve => require(['@/views/report/xiangqing/ji_gou_xiang_qing'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/big_shang_men_fu_wu',
        name: 'big_shang_men_fu_wu',
        component: resolve => require(['@/views/report/xiangqing/big_shang_men_fu_wu'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/di_bao',
        name: 'di_bao',
        component: resolve => require(['@/views/report/xiangqing/di_bao'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/gao_ning',
        name: 'gao_ning',
        component: resolve => require(['@/views/report/xiangqing/gao_ning'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_200',
        name: 'report_big_screen_200',
        component: resolve => require(['@/views/report/report_big_screen_200'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/yongai/ji_gou_lie_biao',
        name: 'ji_gou_biao',
        component: resolve => require(['@/views/report/yongai/ji_gou_lie_biao'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/yongai/ji_gou_xiang_qing',
        name: 'ji_gou_xiang',
        component: resolve => require(['@/views/report/yongai/ji_gou_xiang_qing'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/big_gai_zhao_ty',
        name: 'xiangqing/big_gai_zhao_ty',
        component: resolve => require(['@/views/report/xiangqing/big_gai_zhao_ty'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_201',
        name: 'report_big_screen_201',
        component: resolve => require(['@/views/report/report_big_screen_201'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_202',
        name: 'report_big_screen_202',
        component: resolve => require(['@/views/report/report_big_screen_202'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/aged_info',
        name: 'aged_info',
        component: resolve => require(['@/views/report/xiangqing/aged_info'],resolve),
        meta:{
            title: '长者详情',
            keepAlive: false
        }
    },{
        path: '/report/xiangqing/aged_shen_qing',
        name: 'aged_shen_qing',
        component: resolve => require(['@/views/report/xiangqing/aged_shen_qing'],resolve),
        meta:{
            title: '服务申请',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_80',
        name: 'report_big_screen_80',
        component: resolve => require(['@/views/report/report_big_screen_80'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_82',
        name: 'report_big_screen_82',
        component: resolve => require(['@/views/report/report_big_screen_82'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_81',
        name: 'report_big_screen_81',
        component: resolve => require(['@/views/report/report_big_screen_81'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/report_big_screen_6',
        name: 'report_big_screen_6',
        component: resolve => require(['@/views/report/report_big_screen_6'],resolve),
        meta:{
            title: '智慧物联网云平台',
            keepAlive: false
        }
    },{
        path: '/report/aged/tfga',
        name: 'tfga',
        component: resolve => require(['@/views/report/aged/tfga'],resolve),
        meta:{
            title: '探访关爱',
            keepAlive: false
        }
    },{
        path: '/report/aged/slh_aged_wx',
        name: 'slh_aged_wx',
        component: resolve => require(['@/views/report/aged/slh_aged_wx'],resolve),
        meta:{
            title: '改造档案',
            keepAlive: false
        }
    },{
        path: '/report/aged/slh_aged_pg_wx',
        name: 'slh_aged_pg_wx',
        component: resolve => require(['@/views/report/aged/slh_aged_pg_wx'],resolve),
        meta:{
            title: '改造档案',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_IdCard',
        name: 'wechat_IdCard',
        component: resolve => require(['@/views/report/aged/wechat_IdCard'],resolve),
        meta:{
            title: '智能胸卡',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_shouhuan',
        name: 'wechat_shouhuan',
        component: resolve => require(['@/views/report/aged/wechat_shouhuan'],resolve),
        meta:{
            title: '智能手环',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_XueYaYi',
        name: 'wechat_XueYaYi',
        component: resolve => require(['@/views/report/aged/wechat_XueYaYi'],resolve),
        meta:{
            title: '血压仪',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_XueTangYi',
        name: 'wechat_XueTangYi',
        component: resolve => require(['@/views/report/aged/wechat_XueTangYi'],resolve),
        meta:{
            title: '血糖仪',
            keepAlive: false
        }
    },
    {
        path: '/qinglanradar/multifunctionRadarStart',
        name: 'multifunctionRadarStart',
        component: resolve => require(['@/views/qinglanradar/multifunctionRadarStart'],resolve),
        meta:{
            title: '多功能雷达波',
            keepAlive: false
        }
    },
    {
        path: '/healthentiretyequipment/showHealthEquipment',
        name: 'showHealthEquipment',
        component: resolve => require(['@/views/healthentiretyequipment/showHealthEquipment'],resolve),
        meta:{
            title: '健康一体机健康数据',
            keepAlive: false
        }
    },
    {
        path: '/report/aged/wechat_whiteList',
        name: 'wechat_whiteList',
        component: resolve => require(['@/views/report/aged/wechat_whiteList'],resolve),
        meta:{
            title: '白名单设置',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_accessControl',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_accessControl'],resolve),
        meta:{
            title: '门禁开控制',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_healthAbility_img',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_healthAbility_img'],resolve),
        meta:{
            title: '能力评估图片上传',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_fourSoS_Phone',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_fourSoS_Phone'],resolve),
        meta:{
            title: '4gSoS电话设置',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_YunXinSOS',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_YunXinSOS'],resolve),
        meta:{
            title: '云心SoS设置',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_TumbleRadar',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_TumbleRadar'],resolve),
        meta:{
            title: '新版雷达波绑定',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_XingMai',
        name: 'wechat_accessControl',
        component: resolve => require(['@/views/report/aged/wechat_XingMai'],resolve),
        meta:{
            title: '血压折线图',
            keepAlive: false
        }
    },{
        path: '/vr/vrConfig/:id',
        component: () => import('@/views/vr/vrExhibition/config'),
        meta:{
            title: '场景配置',
            keepAlive: false
        }
    },{
        path: '/vr/vrPreview/:id',
        component: () => import('@/views/vr/vrExhibition/preview'),
        meta:{
            title: '场景预览',
            keepAlive: false
        }
    },{
        path: '/vr/vrScenePreview/:id',
        component: () => import('@/views/vr/vrScene/preview'),
        meta:{
            title: '场景预览',
            keepAlive: false
        }
    }, {
        path: '/vr/vrWay',
        component: () => import('@/views/vr/vrExhibition/way'),
        meta: {
            title: '轨迹漫游',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_agedResidence',
        name: 'wechat_agedResidence',
        component: resolve => require(['@/views/report/aged/wechat_agedResidence'],resolve),
        meta:{
            title: '住宅管理',
            keepAlive: false
        }
    },{
        path: '/report/aged/wechat_agedDelivery',
        name: 'wechat_agedDelivery',
        component: resolve => require(['@/views/report/aged/wechat_agedDelivery'],resolve),
        meta:{
            title: '送货管理',
            keepAlive: false
        }
    },{
        path: '/call/test',
        name: 'call/test',
        component: resolve => require(['@/views/call/test'],resolve),
        meta:{
            title: '护士台',
            keepAlive: false
        }
    },{
        path: '/kasnshituIpad',
        name: 'kasnshituIpad',
        component: resolve => require(['@/views/kasn/kasnshituIpad.vue'],resolve),
        meta:{
            title: '定位',
            keepAlive: false
        }
    },{
        path: '/report/pg/stay_assessment',
        name: 'stay_assessment',
        component: resolve => require(['@/views/report/pg/stay_assessment.vue'],resolve),
        meta:{
            title: '待评估',
            keepAlive: false
        }
    },{
        path: '/report/pg/ability_assessment2022',
        name: 'ability_assessment2022',
        component: resolve => require(['@/views/report/pg/ability_assessment2022.vue'],resolve),
        meta:{
            title: '能力评估',
            keepAlive: false
        }
    },{
        path: '/report/pg/member_upd',
        name: 'member_upd',
        component: resolve => require(['@/views/report/pg/member_upd.vue'],resolve),
        meta:{
            title: '会员编辑',
            keepAlive: false
        }
    },{
        path: '/wechat/login',
        name: 'login',
        component: resolve => require(['@/views/wechat/login.vue'],resolve),
        meta:{
            title: '登录',
            keepAlive: false
        }
    },{
        path: '/supplyChain/productNEW',
        name: 'productNEW',
        component: resolve => require(['@/views/supplyChain/productNEW'],resolve),
        meta:{
            title: '产品详情页面',
            keepAlive: false
        }
    },{
        path: '/game',
        name: 'gameIndex',
        component: resolve => require(['@/views/exam/GameIndex'],resolve),
        meta:{
            title: '产品详情页面',
            keepAlive: false
        }
    },{
        path: '/login2',
        name: 'login2',
        component: resolve => require(['@/views/login2.vue'],resolve),
        meta:{
            title: '登陆页',
            keepAlive: false
        }
    },{
        path: '/monitor/camera_h5',
        name: 'camera_h5',
        component: resolve => require(['@/views/monitor/camera_h5'],resolve),
        meta:{
            title: '机器人巡房',
            keepAlive: false
        }
    },{
        path: '/rehabcare/medical_order_execution_h5',
        name: 'medical_order_execution_h5',
        component: resolve => require(['@/views/rehabcare/medical_order_execution_h5'],resolve),
        meta:{
            title: '医嘱执行 H5',
            keepAlive: false
        }
    },{
        path: '/rehabcare/rehab_care_execution_h5',
        name: 'rehab_care_execution_h5',
        component: resolve => require(['@/views/rehabcare/rehab_care_execution_h5'],resolve),
        meta:{
            title: '康养护理执行 H5',
            keepAlive: false
        }
    },{
        path: '/app/indexXcx',
        name: 'indexXcx',
        component: resolve => require(['@/views/app/indexXcx'],resolve),
        meta:{
            title: '小程序APP首页',
            keepAlive: false
        }
    },{
        path: '/app/index',
        name: 'index',
        component: resolve => require(['@/views/app/index'],resolve),
        meta:{
            title: 'APP首页',
            keepAlive: false
        }
    },{
        path: '/app/aged',
        name: 'aged',
        component: resolve => require(['@/views/app/aged'],resolve),
        meta:{
            title: 'APP长者档案',
            keepAlive: false
        }
    },{
        path: '/app/assessment_pg',
        name: 'assessment_pg',
        component: resolve => require(['@/views/app/assessment_pg'],resolve),
        meta:{
            title: 'APP能力评估',
            keepAlive: false
        }
    },{
        path: '/app/cognitive_assessment',
        name: 'cognitive_assessment',
        component: resolve => require(['@/views/exam/jiqirenui/CognitiveAssessment'],resolve),
        meta:{
            title: '认知评估',
            keepAlive: false
        }
    },{
        path: '/app/cognitive_training',
        name: 'cognitive_training',
        component: resolve => require(['@/views/exam/jiqirenui/CognitiveTraining'],resolve),
        meta:{
            title: '认知训练',
            keepAlive: false
        }
    },{
        path: '/app/scale_assessment',
        name: 'scale_assessment',
        component: resolve => require(['@/views/exam/jiqirenui/ScaleAssessment'],resolve),
        meta:{
            title: '量表评定',
            keepAlive: false
        }
    },{
        path: '/app/login',
        name: 'login',
        component: resolve => require(['@/views/app/login'],resolve),
        meta:{
            title: 'APP登陆',
            keepAlive: false
        }
    },{
        path: '/bdsxt/token',
        name: 'login',
        component: resolve => require(['@/views/bdsxt/token'],resolve),
        meta:{
            title: '本地录像',
            keepAlive: false
        }
    },{
        path: '/ai/ai_evaluation_table',
        name: 'ai_evaluation_table',
        component: resolve => require(['@/views/ai/ai_evaluation_table.vue'],resolve),
        meta:{
            title: '评估表',
            keepAlive: false
        }
    },{
        path: '/ai/ai_evaluation_room_camera',
        name: 'ai_evaluation_room_camera',
        component: resolve => require(['@/views/ai/ai_evaluation_room_camera.vue'],resolve),
        meta:{
            title: '摄像头',
            keepAlive: false
        }
    },{
        path: '/ai/ai_evaluation_room_badge',
        name: 'ai_evaluation_room_badge',
        component: resolve => require(['@/views/ai/ai_evaluation_room_badge.vue'],resolve),
        meta:{
            title: '胸卡',
            keepAlive: false
        }
    },{
        path: '/ai/cameraPlay',
        name: 'cameraPlay',
        component: resolve => require(['@/views/ai/cameraPlay.vue'],resolve),
        meta:{
            title: '录像播放',
            keepAlive: false
        }
    },{
        path: '/robot/robot_patrol_record',
        name: 'robot_patrol_record',
        component: resolve => require(['@/views/robot/robot_patrol_record.vue'],resolve),
        meta:{
            title: '机器人巡查记录',
            keepAlive: false
        }
    },{
        path: '/qinlu/AgoraCall',
        name: 'AgoraCall',
        component: resolve => require(['@/views/qinlu/AgoraCall.vue'],resolve),
        meta:{
            title: '视频',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold',
        name: 'hearThreshold',
        component: resolve => require(['@/views/hear/h5/threshold/index.vue'],resolve),
        meta:{
            title: '听力测试-选择老人',
            keepAlive: false
        }
    },{
        path: '/aged/health_monitor/h5',
        name: 'healthMonitorH5',
        component: resolve => require(['@/views/aged/health_monitor/monitor_h5.vue'],resolve),
        meta:{
            title: '健康监测',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold/main',
        name: 'hearThresholdMain',
        component: resolve => require(['@/views/hear/h5/threshold/threshold.vue'],resolve),
        meta:{
            title: '听阈敏感',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold/intro',
        name: 'hearThresholdIntro',
        component: resolve => require(['@/views/hear/h5/threshold/intro.vue'],resolve),
        meta:{
            title: '纯音听阈测试介绍',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold/test',
        name: 'hearThresholdTest',
        component: resolve => require(['@/views/hear/h5/threshold/test.vue'],resolve),
        meta:{
            title: '测试信息',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold/env-test',
        name: 'hearThresholdEnvTest',
        component: resolve => require(['@/views/hear/h5/threshold/env-test.vue'],resolve),
        meta:{
            title: '环境音检测',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold/audiometry-test',
        name: 'hearThresholdAudiometryTest',
        component: resolve => require(['@/views/hear/h5/threshold/audiometry-test.vue'],resolve),
        meta:{
            title: '纯音听阈测试',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold/result',
        name: 'hearThresholdResult',
        component: resolve => require(['@/views/hear/h5/threshold/result.vue'],resolve),
        meta:{
            title: '测试结果',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold/report-list',
        name: 'hearThresholdReportList',
        component: resolve => require(['@/views/hear/h5/threshold/report-list.vue'],resolve),
        meta:{
            title: '测试报告',
            keepAlive: false
        }
    },{
        path: '/hear/h5/threshold/analysis',
        name: 'hearThresholdAnalysis',
        component: resolve => require(['@/views/hear/h5/threshold/analysis.vue'],resolve),
        meta:{
            title: '听力图报告',
            keepAlive: false
        }
    },{
        path: '/hear/h5/speech',
        name: 'hearSpeech',
        component: resolve => require(['@/views/hear/h5/speech/index.vue'],resolve),
        meta:{
            title: '言语识别-选择老人',
            keepAlive: false
        }
    },{
        path: '/hear/h5/speech/main',
        name: 'hearSpeechMain',
        component: resolve => require(['@/views/hear/h5/speech/speech.vue'],resolve),
        meta:{
            title: '言语识别',
            keepAlive: false
        }
    },{
        path: '/hear/h5/speech/intro',
        name: 'hearSpeechIntro',
        component: resolve => require(['@/views/hear/h5/speech/intro.vue'],resolve),
        meta:{
            title: '言语识别测试介绍',
            keepAlive: false
        }
    },{
        path: '/hear/h5/speech/test',
        name: 'hearSpeechTest',
        component: resolve => require(['@/views/hear/h5/speech/test.vue'],resolve),
        meta:{
            title: '言语识别测试',
            keepAlive: false
        }
    },{
        path: '/hear/h5/speech/result',
        name: 'hearSpeechResult',
        component: resolve => require(['@/views/hear/h5/speech/result.vue'],resolve),
        meta:{
            title: '测试结果',
            keepAlive: false
        }
    },{
        path: '/hear/h5/speech/report-list',
        name: 'hearSpeechReportList',
        component: resolve => require(['@/views/hear/h5/speech/report-list.vue'],resolve),
        meta:{
            title: '测试报告',
            keepAlive: false
        }
    },{
        path: '/hear/h5/speech/analysis',
        name: 'hearSpeechAnalysis',
        component: resolve => require(['@/views/hear/h5/speech/analysis.vue'],resolve),
        meta:{
            title: '言语识别分析报告',
            keepAlive: false
        }
    },{
        path: '/hear/h5/selectAged',
        name: 'hearSelectAged',
        component: resolve => require(['@/views/hear/h5/home/select-aged.vue'],resolve),
        meta:{
            title: '听力评估-选择老人',
            keepAlive: false
        }
    },{
        path: '/hear/h5/home',
        name: 'hearHome',
        component: resolve => require(['@/views/hear/h5/home/index.vue'],resolve),
        meta:{
            title: '听觉能力评估',
            keepAlive: false
        }
    },{
        path: '/hear/h5/selfCheck',
        name: 'hearSelfCheck',
        component: resolve => require(['@/views/hear/h5/self-check/index.vue'],resolve),
        meta:{
            title: '听力障碍自查',
            keepAlive: false
        }
    },{
        path: '/hear/h5/handbook',
        name: 'hearHandbook',
        component: resolve => require(['@/views/hear/h5/handbook/index.vue'],resolve),
        meta:{
            title: '听力宝典',
            keepAlive: false
        }
    },{
        path: '/hear/h5/handbook/detail',
        name: 'hearHandbookDetail',
        component: resolve => require(['@/views/hear/h5/handbook/detail.vue'],resolve),
        meta:{
            title: '听力宝典-文章',
            keepAlive: false
        }
    },{
        path: '/hear/h5/simulator',
        name: 'hearSimulator',
        component: resolve => require(['@/views/hear/h5/simulator/index.vue'],resolve),
        meta:{
            title: '听觉模拟室',
            keepAlive: false
        }
    },{
        path: '/sign/h5',
        name: 'signAgedIndex',
        component: resolve => require(['@/views/sign/h5/index.vue'],resolve),
        meta:{
            title: '签名-选择老人',
            keepAlive: false
        }
    },{
        path: '/sign/h5/fileList',
        name: 'signFileList',
        component: resolve => require(['@/views/sign/h5/fileList.vue'],resolve),
        meta:{
            title: '待签名文件',
            keepAlive: false
        }
    },{
        path: '/sign/h5/params',
        name: 'signParams',
        component: resolve => require(['@/views/sign/h5/params.vue'],resolve),
        meta:{
            title: '参数设置',
            keepAlive: false
        }
    },{
        path: '/sign/h5/sign',
        name: 'signFileSign',
        component: resolve => require(['@/views/sign/h5/sign.vue'],resolve),
        meta:{
            title: '文件签署',
            keepAlive: false
        }
    },{
        path: '/sign/h5/caregiverFileList',
        name: 'signCaregiverFileList',
        component: resolve => require(['@/views/sign/h5/caregiverFileList.vue'],resolve),
        meta:{
            title: '护工待签字文件',
            keepAlive: false
        }
    },

    // ─── HIS 医院信息系统 ──────────────────────────────────────────
    // 门诊
    { path: '/his/opd/workstation', name: 'hisOpdWorkstation', component: resolve => require(['@/views/his/opd/opd_workstation.vue'], resolve), meta: { title: '门诊工作站', keepAlive: false } },
    { path: '/his/opd/register',    name: 'hisOpdRegister',    component: resolve => require(['@/views/his/opd/opd_register.vue'],    resolve), meta: { title: '挂号管理',   keepAlive: false } },
    { path: '/his/opd/billing',     name: 'hisOpdBilling',     component: resolve => require(['@/views/his/opd/opd_billing.vue'],     resolve), meta: { title: '门诊收费',   keepAlive: false } },
    { path: '/his/opd/prescription',name: 'hisOpdPrescription',component: resolve => require(['@/views/his/opd/opd_prescription.vue'],resolve), meta: { title: '处方管理',   keepAlive: false } },
    // 急诊
    { path: '/his/emr/triage',      name: 'hisEmrTriage',      component: resolve => require(['@/views/his/emr/emr_triage.vue'],      resolve), meta: { title: '预检分诊',   keepAlive: false } },
    { path: '/his/emr/workstation', name: 'hisEmrWorkstation', component: resolve => require(['@/views/his/emr/emr_workstation.vue'], resolve), meta: { title: '急诊工作站', keepAlive: false } },
    { path: '/his/emr/observe',     name: 'hisEmrObserve',     component: resolve => require(['@/views/his/emr/emr_observe.vue'],     resolve), meta: { title: '留观管理',   keepAlive: false } },
    // 住院
    { path: '/his/inp/admission',   name: 'hisInpAdmission',   component: resolve => require(['@/views/his/inp/inp_admission.vue'],   resolve), meta: { title: '入院登记',   keepAlive: false } },
    { path: '/his/inp/ward',        name: 'hisInpWard',        component: resolve => require(['@/views/his/inp/inp_ward.vue'],        resolve), meta: { title: '病区管理',   keepAlive: false } },
    { path: '/his/inp/doctor',      name: 'hisInpDoctor',      component: resolve => require(['@/views/his/inp/inp_doctor.vue'],      resolve), meta: { title: '医生工作站', keepAlive: false } },
    { path: '/his/inp/nurse',       name: 'hisInpNurse',       component: resolve => require(['@/views/his/inp/inp_nurse.vue'],       resolve), meta: { title: '护士工作站', keepAlive: false } },
    { path: '/his/inp/discharge',   name: 'hisInpDischarge',   component: resolve => require(['@/views/his/inp/inp_discharge.vue'],   resolve), meta: { title: '出院管理',   keepAlive: false } },
    // 护理
    { path: '/his/nur/assessment',  name: 'hisNurAssessment',  component: resolve => require(['@/views/his/nur/nur_assessment.vue'],  resolve), meta: { title: '护理评估',   keepAlive: false } },
    { path: '/his/nur/plan',        name: 'hisNurPlan',        component: resolve => require(['@/views/his/nur/nur_plan.vue'],        resolve), meta: { title: '护理计划',   keepAlive: false } },
    { path: '/his/nur/record',      name: 'hisNurRecord',      component: resolve => require(['@/views/his/nur/nur_record.vue'],      resolve), meta: { title: '护理记录',   keepAlive: false } },
    // 药房
    { path: '/his/phar/dispense',   name: 'hisPharDispense',   component: resolve => require(['@/views/his/phar/phar_dispense.vue'],  resolve), meta: { title: '药品调剂',   keepAlive: false } },
    { path: '/his/phar/stock',      name: 'hisPharStock',      component: resolve => require(['@/views/his/phar/phar_stock.vue'],     resolve), meta: { title: '药品库存',   keepAlive: false } },
    { path: '/his/phar/review',     name: 'hisPharReview',     component: resolve => require(['@/views/his/phar/phar_review.vue'],    resolve), meta: { title: '药师审方',   keepAlive: false } },
    { path: '/his/phar/purchase',   name: 'hisPharPurchase',   component: resolve => require(['@/views/his/phar/phar_purchase.vue'],  resolve), meta: { title: '采购管理',   keepAlive: false } },
    // 检验
    { path: '/his/lab/order',       name: 'hisLabOrder',       component: resolve => require(['@/views/his/lab/lab_order.vue'],       resolve), meta: { title: '检验申请',   keepAlive: false } },
    { path: '/his/lab/result',      name: 'hisLabResult',      component: resolve => require(['@/views/his/lab/lab_result.vue'],      resolve), meta: { title: '检验结果',   keepAlive: false } },
    { path: '/his/lab/critical',    name: 'hisLabCritical',    component: resolve => require(['@/views/his/lab/lab_critical.vue'],    resolve), meta: { title: '危急值管理', keepAlive: false } },
    // 影像
    { path: '/his/img/order',       name: 'hisImgOrder',       component: resolve => require(['@/views/his/img/img_order.vue'],       resolve), meta: { title: '影像申请',   keepAlive: false } },
    { path: '/his/img/report',      name: 'hisImgReport',      component: resolve => require(['@/views/his/img/img_report.vue'],      resolve), meta: { title: '影像报告',   keepAlive: false } },
    { path: '/his/img/pacs',        name: 'hisImgPacs',        component: resolve => require(['@/views/his/img/img_pacs.vue'],        resolve), meta: { title: 'PACS查阅',   keepAlive: false } },
    // 手术
    { path: '/his/oper/schedule',   name: 'hisOperSchedule',   component: resolve => require(['@/views/his/oper/oper_schedule.vue'],  resolve), meta: { title: '手术排程',   keepAlive: false } },
    { path: '/his/oper/record',     name: 'hisOperRecord',     component: resolve => require(['@/views/his/oper/oper_record.vue'],    resolve), meta: { title: '手术记录',   keepAlive: false } },
    { path: '/his/oper/anesthesia', name: 'hisOperAnesthesia', component: resolve => require(['@/views/his/oper/oper_anesthesia.vue'],resolve), meta: { title: '麻醉管理',   keepAlive: false } },
    // 医务管理
    { path: '/his/mgmt/staff',      name: 'hisMgmtStaff',      component: resolve => require(['@/views/his/mgmt/mgmt_staff.vue'],     resolve), meta: { title: '人员管理',   keepAlive: false } },
    { path: '/his/mgmt/dept',       name: 'hisMgmtDept',       component: resolve => require(['@/views/his/mgmt/mgmt_dept.vue'],      resolve), meta: { title: '科室管理',   keepAlive: false } },
    { path: '/his/mgmt/schedule',   name: 'hisMgmtSchedule',   component: resolve => require(['@/views/his/mgmt/mgmt_schedule.vue'],  resolve), meta: { title: '排班管理',   keepAlive: false } },
    { path: '/his/mgmt/duty',       name: 'hisMgmtDuty',       component: resolve => require(['@/views/his/mgmt/mgmt_duty.vue'],      resolve), meta: { title: '值班管理',   keepAlive: false } },
    // 质控
    { path: '/his/qc/indicator',    name: 'hisQcIndicator',    component: resolve => require(['@/views/his/qc/qc_indicator.vue'],     resolve), meta: { title: '质控指标',   keepAlive: false } },
    { path: '/his/qc/event',        name: 'hisQcEvent',        component: resolve => require(['@/views/his/qc/qc_event.vue'],         resolve), meta: { title: '不良事件',   keepAlive: false } },
    { path: '/his/qc/infection',    name: 'hisQcInfection',    component: resolve => require(['@/views/his/qc/qc_infection.vue'],     resolve), meta: { title: '院感管理',   keepAlive: false } },
    // 统计分析
    { path: '/his/stat/opd',        name: 'hisStatOpd',        component: resolve => require(['@/views/his/stat/stat_opd.vue'],       resolve), meta: { title: '门诊统计',   keepAlive: false } },
    { path: '/his/stat/inp',        name: 'hisStatInp',        component: resolve => require(['@/views/his/stat/stat_inp.vue'],       resolve), meta: { title: '住院统计',   keepAlive: false } },
    { path: '/his/stat/finance',    name: 'hisStatFinance',    component: resolve => require(['@/views/his/stat/stat_finance.vue'],   resolve), meta: { title: '财务统计',   keepAlive: false } },
    { path: '/his/stat/perf',       name: 'hisStatPerf',       component: resolve => require(['@/views/his/stat/stat_perf.vue'],      resolve), meta: { title: '绩效分析',   keepAlive: false } },
    // 系统管理
    { path: '/his/sys/dict',        name: 'hisSysDict',        component: resolve => require(['@/views/his/sys/sys_dict.vue'],        resolve), meta: { title: '字典维护',   keepAlive: false } },
    { path: '/his/sys/log',         name: 'hisSysLog',         component: resolve => require(['@/views/his/sys/sys_log.vue'],         resolve), meta: { title: '操作日志',   keepAlive: false } },
    { path: '/his/sys/backup',      name: 'hisSysBackup',      component: resolve => require(['@/views/his/sys/sys_backup.vue'],      resolve), meta: { title: '数据备份',   keepAlive: false } }
    // ─────────────────────────────────────────────────────────────


]

// HIS 页面需要挂在 index 主框架下，由 index.vue 的 router-view 承载。
const indexRoute = routes.find(route => route.name === 'index')
const hisRoutes = routes.filter(route => route.path.startsWith('/his/'))
if (indexRoute && hisRoutes.length) {
    indexRoute.children.push(...hisRoutes)
    for (let i = routes.length - 1; i >= 0; i--) {
        if (routes[i].path.startsWith('/his/')) routes.splice(i, 1)
    }
}

// const createRouter = () =>
//     new VueRouter({
//       mode: 'history', // 去掉url中的#
//       scrollBehavior: () => ({ y: 0 }),
//       routes
//     });
//
// const router = createRouter();

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}


// // 定义一个resetRouter 方法，在退出登录时，调用即可
// export function resetRouter() {
//   const newRouter = createRouter();
//   router.matcher = newRouter.match();
// }

const router  = new VueRouter({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    routes
})





export default router
